import React, { useEffect, useState } from 'react'
import { useHistory, useLocation } from "react-router-dom";
import PlantillaScreen from '../../helpers/PlantillaScreen';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { LoaderScreen } from '../../components/LoaderScreen';
import request from '../../../Helpers/API';
import { Input, Select, MenuItem, InputLabel, FormControl } from '@mui/material';
import SaveIcon from "@mui/icons-material/Save";


export const ScorecardRealVendedor = () => {
  const location = useLocation();
  const history = useHistory();
  const [Cambio, setCambio] = useState([]);
  const [data, setData] = useState([]);
  const [nuevosDatos, setNuevosDatos] = useState([]);
  const [ejercicio, setEjercicio] = useState('');
  var ejercicioActual;


  const onBack = () => {
    history.push("/Ventas/ScorecardRealVendedores")
  };

  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });

  const onhandleChangeEjercicio = (event) => {
    setEjercicio(event.target.value);
    ejercicioActual = event.target.value;
  };

  useEffect(() => {
    setLoader({ ...loader, mostrar: true });
    request
      .get(`CargaScorecardVendedor/MostrarScorecardRealVendedor?ejercicio=${ejercicio}&vendedor=${location.state.idempleado}`)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        setData(result);
        setCambio(result);
        setNuevosDatos(result); // Inicializar nuevosDatos con los datos cargados
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
      });
  }, [ejercicio]);

  const onKeyDown = (event, index) => {
    if (event.key === "ArrowRight") {
      const nextCell = event.target.parentElement.nextElementSibling.firstElementChild;
      if (nextCell && event.target.tabIndex < index * 14 + 13) {
        nextCell.focus();
      }
    } else if (event.key === "ArrowLeft") {
      const prevCell = event.target.parentElement.previousElementSibling.firstElementChild;
      if (prevCell) {
        prevCell.focus();
      }
    } else if (event.key === "ArrowDown") {
      const nextRow = event.target.closest("tr").nextElementSibling;
      if (nextRow) {
        nextRow.querySelector("input").focus();
      }
    } else if (event.key === "ArrowUp") {
      const prevRow = event.target.closest("tr").previousElementSibling;
      if (prevRow) {
        prevRow.querySelector("input").focus();
      }
    }
  };

  const onKeyDown2 = (event, index) => {
    if (event.key === "ArrowLeft") {
      const prevCell = event.target.parentElement.previousElementSibling.firstElementChild;
      if (prevCell) {
        prevCell.focus();
      }
    } else if (event.key === "ArrowDown") {
      const nextRow = event.target.closest("tr").nextElementSibling;
      if (nextRow) {
        nextRow.querySelector("input").focus();
      }
    } else if (event.key === "ArrowUp") {
      const prevRow = event.target.closest("tr").previousElementSibling;
      if (prevRow) {
        prevRow.querySelector("input").focus();
      }
    }
  };

  const handleChange = (event, index, fieldName) => {
    const nuevosDatosTemp = [...Cambio]; // Copiar el estado actual de los datos editados
    nuevosDatosTemp[index][fieldName] = event.target.value;
    setCambio(nuevosDatosTemp); // Actualizar el estado de datos editados
    setNuevosDatos(nuevosDatosTemp); // Guardar datos para acceso en onGuardar
    // console.log (JSON.stringify(nuevosDatos));
  };


  const onGuardar = () => {
    setLoader({ ...loader, mostrar: true });
    const mdl = {
      idproyeccion: -999,
      ejercicio: ejercicio,
      periodo: 12,
      sucursal: location.state.idSucursal,
      idvendedor: location.state.idempleado,
      idlinea: 1,
      objetivo: 4,
      unidades_vendidas: 3,
      objetivo_habilitado: 1,
      unidades_vendidas_habilitado: 1,
      scorecard_detalle: JSON.stringify(nuevosDatos),
      // usuario: 8919
    }
    request
      .post(`GuardaScorecardVendedor/GuardarReal`, mdl)
      .then(response => {
        setLoader({ ...loader, mostrar: false });
      })
      .catch((error) => {
        console.log(error);
        setLoader({ ...loader, mostrar: false });
      });
  };

  return (
    <PlantillaScreen
      titulo={"SCORECARD REAL DE " + location.state.empleado.toUpperCase()}
      className_main={1}
      className={"scorecard-vendedor"}
    >

      <LoaderScreen loader={loader} />
      <div className='scorecard-guardar-container-button-footer'>
        <button onClick={() => onGuardar()}
          className='scorecard-guardar-container-button-btn'>
          <SaveIcon />
          Guardar</button>
        <div className='back'
          onClick={() => onBack()}
        >
          <ArrowBackIcon /> Regresar
        </div>
      </div>

      <div className='scorecard-vendedor-encabezado scroll-4'>
        <div className='scorecard-vendedor-container'>
          <div className='combobox-ejercicio'>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Ejercicio</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                label="ejercicio"
                onChange={(event) => onhandleChangeEjercicio(event)}
              >
                <MenuItem value="2023">2023</MenuItem>
                <MenuItem value="2024">2024</MenuItem>
                <MenuItem value="2025">2025</MenuItem>
              </Select>
            </FormControl>
          </div>
          <div className='scorecard-vendedor-tabla'>
            <table cellPadding={0} cellSpacing={0}>
              <thead>
                <tr>
                  <th>ID de Línea</th>
                  <th>
                    <div>Línea</div>
                  </th>
                  <th>
                    <div>Enero</div>
                  </th>
                  <th>
                    <div>Febrero</div>
                  </th>
                  <th>
                    <div>Marzo</div>
                  </th>
                  <th>
                    <div>Abril</div>
                  </th>
                  <th>
                    <div>Mayo</div>
                  </th>
                  <th>
                    <div>Junio</div>
                  </th>
                  <th>
                    <div>Julio</div>
                  </th>
                  <th>
                    <div>Agosto</div>
                  </th>
                  <th>
                    <div>Septiembre</div>
                  </th>
                  <th>
                    <div>Octubre</div>
                  </th>
                  <th>
                    <div>Noviembre</div>
                  </th>
                  <th>
                    <div>Diciembre</div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {data.map((item, index) => (
                  <tr key={index}>
                    <td className='columna-centrada'>{item.idlinea}</td>
                    <td>{item.linea}</td>
                    <td className='columna-centrada' tabIndex={index * 14 + 1}><input type="text" value={item.enero} onChange={(event) => handleChange(event, index, "enero")} onKeyDown={(event) => onKeyDown(event, index)} /></td>
                    <td className='columna-centrada' tabIndex={index * 14 + 2}><input type="text" value={item.febrero} onChange={(event) => handleChange(event, index, "febrero")} onKeyDown={(event) => onKeyDown(event, index)} /></td>
                    <td className='columna-centrada' tabIndex={index * 14 + 3}><input type="text" value={item.marzo} onChange={(event) => handleChange(event, index, "marzo")} onKeyDown={(event) => onKeyDown(event, index)} /></td>
                    <td className='columna-centrada' tabIndex={index * 14 + 4}><input type="text" value={item.abril} onChange={(event) => handleChange(event, index, "abril")} onKeyDown={(event) => onKeyDown(event, index)} /></td>
                    <td className='columna-centrada' tabIndex={index * 14 + 5}><input type="text" value={item.mayo} onChange={(event) => handleChange(event, index, "mayo")} onKeyDown={(event) => onKeyDown(event, index)} /></td>
                    <td className='columna-centrada' tabIndex={index * 14 + 6}><input type="text" value={item.junio} onChange={(event) => handleChange(event, index, "junio")} onKeyDown={(event) => onKeyDown(event, index)} /></td>
                    <td className='columna-centrada' tabIndex={index * 14 + 7}><input type="text" value={item.julio} onChange={(event) => handleChange(event, index, "julio")} onKeyDown={(event) => onKeyDown(event, index)} /></td>
                    <td className='columna-centrada' tabIndex={index * 14 + 8}><input type="text" value={item.agosto} onChange={(event) => handleChange(event, index, "agosto")} onKeyDown={(event) => onKeyDown(event, index)} /></td>
                    <td className='columna-centrada' tabIndex={index * 14 + 9}><input type="text" value={item.septiembre} onChange={(event) => handleChange(event, index, "septiembre")} onKeyDown={(event) => onKeyDown(event, index)} /></td>
                    <td className='columna-centrada' tabIndex={index * 14 + 10}><input type="text" value={item.octubre} onChange={(event) => handleChange(event, index, "octubre")} onKeyDown={(event) => onKeyDown(event, index)} /></td>
                    <td className='columna-centrada' tabIndex={index * 14 + 11}><input type="text" value={item.noviembre} onChange={(event) => handleChange(event, index, "noviembre")} onKeyDown={(event) => onKeyDown(event, index)} /></td>
                    <td className='columna-centrada' tabIndex={index * 14 + 12}><input type="text" value={item.diciembre} onChange={(event) => handleChange(event, index, "diciembre")} onKeyDown={(event) => onKeyDown2(event, index)} /></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </PlantillaScreen>
  )


}
